import i18next from 'i18next';
import moment from 'moment';
import 'moment/locale/es';
import 'moment/locale/en-gb';

export const toLocaleNumber = (value: number | undefined | null): string => {
  if (value === undefined || value === null) return '';
  return new Intl.NumberFormat(i18next.language).format(value);
};

export const toLocaleDate = (date?: Date): string => {
  if (date === undefined) return '';
  return moment(date).locale(i18next.language).format('L');
};

export const getDateFormatted = (): string => {
  return moment().locale(i18next.language).format('YYYYMMDDHHmmss');
};
